const getters = {
  videos: state => Object.values(state.videos),
  folders: state => Object.values(state.folders),
  emailConfirmed: state => state.user.email_confirmed,
  canCreateUsers: state =>
    state.user.is_group_admin ||
    state.user.is_coach ||
    state.user.is_diy,
  groupCount: state => state.user.groups.length,
}

export default getters



// WEBPACK FOOTER //
// ./src/getters.js